import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class FormInputCharCounterComponent extends React.Component {
    static propTypes = {
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        maxChars: PropTypes.number
    };
    static defaultProps = {
        value: '',
        maxChars: null
    };

    render() {
        const { maxChars } = this.props;

        let displayStyle = '';
        const valueLength = this.props.value.toString().length;
        if (this.props.maxChars && valueLength > this.props.maxChars) {
            displayStyle = 'alert';
        }

        return (
            <div className="component-form-input-char-counter">
                <span className={`counter ${displayStyle}`}>{valueLength}{maxChars && `/${maxChars}`}</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms2/InputCharCounter/index.js